<div [hidden]="!statusText">{{ statusText }}</div>
